import meghaviData from '../data/meghaviCaseStudy.json';

export const MEGHAVI_FALLBACK = meghaviData;

/** Shown on listing page when API has no entries yet */
export const FALLBACK_CASE_STUDIES = [meghaviData];
